import { render, staticRenderFns } from "./ExtendOtherNutrientsMagnesium.vue?vue&type=template&id=b36b140a&scoped=true"
import script from "./ExtendOtherNutrientsMagnesium.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsMagnesium.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsMagnesium.vue?vue&type=style&index=0&id=b36b140a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b140a",
  null
  
)

export default component.exports